import PropTypes from "prop-types";

const nodeShape = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLeaf: PropTypes.bool,
  tooltipText: PropTypes.string,
  checkboxTooltipText: PropTypes.string
};

const nodeShapeWithChildren = PropTypes.oneOfType([
  PropTypes.shape(nodeShape),
  PropTypes.shape({
    ...nodeShape,
    children: PropTypes.arrayOf(nodeShape)
  })
]);

export default nodeShapeWithChildren;
